import React from "react";
import { Field } from "formik";
import InputMask from "react-input-mask";
export const Input = (props) => {
  return (
    <div className="form-item">
      <div className="form-input-label">{props.label}</div>
      <input className="form-input-style" {...props}>
        {props.children}
      </input>
      {props.errorText && (
        <div className="form-input-error">{props.errorText}</div>
      )}
    </div>
  );
};

export const FormikField = (props) => {
  return (
    <div className="form-item">
      <div className="form-input-label">{props.label}</div>
      <Field className="form-input-style" {...props}>
        {props.children}
      </Field>
      {/* {props.errorText && props.touched && ( */}
      <div className={`error-message ${props.errorText ? "active" : ""}`}>
        {props.errorText}
      </div>
      {/* )} */}
    </div>
  );
};

export const PhoneInputUs = ({
  field,
  form: { touched, errors },
  ...props
}) => {
  return (
    <div className="form-item">
      <div className="form-input-label">{props.label}</div>
      <InputMask {...field} {...props} mask="(999) 999-9999">
        {(inputProps) => <input {...inputProps} className="form-input-style" />}
      </InputMask>
      {touched[field.name] && errors[field.name] && (
        <div className="form-input-error">{errors[field.name]}</div>
      )}
    </div>
  );
};
